type Props = {
    productName: string,
    title1: string,
    title2: string,
    title3: string,
    image: string,
    imageWebp: string,
    backgroundClass: string,
};

const Banner = ({
    productName,
    title1,
    title2,
    title3,
    image,
    imageWebp,
    backgroundClass,
}: Props) => (
    <section id="banner" className={`${backgroundClass} pt-3 pb-3`}>
        <div className="container-fluid text-white text-center pb-4">
            <div className="row align-items-center justify-content-center pb-5">
                <div className="col-11 text-center">
                    <h1 className="fw-bold" dangerouslySetInnerHTML={{ __html: productName }}></h1>
                </div>
            </div>
            <div className="row align-items-center justify-content-center">
                <div className="col-lg-2 col-md-3 offset-lg-1 offset-md-1 col-4 order-md-1 order-2">
                    <picture>
                        <source srcSet={imageWebp} type="image/webp" />
                        <img className="img-fluid gg-img-display-product" src={image} loading="lazy"/>
                    </picture>
                </div>
                <div className="col-xl-4 col-md-5 col-10 order-md-2 order-1 text-md-start text-center">
                    <h3 className="fw-bold">{title1}</h3>
                    <h3 className="fw-bold">{title2}</h3>
                    <h3 className="fw-bold">{title3}</h3>
                    <p className="mt-5">Dr. Hart Original Formula - Limited availability!</p>
                </div>
            </div>
        </div>
    </section >
);

export default Banner;